import type { FC } from "react";
import { FloatPoolMatches } from "./FloatPoolMatches";
import { HeldRows } from "./HeldRows";
import { type LoadNursesResults, NursesSummary } from "./NursesSummary";

type Props = {
	results: LoadNursesResults;
	timezone: string | undefined;
	dataTestId: string;
};

/**
 * What a roster load leaves to act on, then its summary — the same on every screen that loads a roster
 * (Data Load and Auto Prompt): held rows to resolve, records to merge, and the copyable summary.
 */
export const RosterLoadResults: FC<Props> = ({ results, timezone, dataTestId }) => (
	<>
		<HeldRows results={results.results} isUpdate={results.is_update} dataTestId={dataTestId} />
		<FloatPoolMatches results={results.results} dataTestId={dataTestId} />
		<NursesSummary results={results} timezone={timezone} />
	</>
);
